import { render, staticRenderFns } from "./editCollection.vue?vue&type=template&id=2ed61411&scoped=true"
import script from "./editCollection.vue?vue&type=script&lang=js"
export * from "./editCollection.vue?vue&type=script&lang=js"
import style0 from "./editCollection.vue?vue&type=style&index=0&id=2ed61411&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed61411",
  null
  
)

export default component.exports